import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
// import AdviceRequests from "../prospect/advicesSent";
import SubDetails from "./subscriptiondetails";
import ExtendSubscription from "./extendSubscription";
// import AdvicesPending from "./advicesPending";
// import RebalanceSent from "./RebalanceSent";
import { investmentDetailsPath } from "../utils/varialbles";
import { useHistory, useLocation } from "react-router-dom";
import { Button, Grid } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

function InvestmentTabs() {
  const classes = useStyles();
  const history = useHistory();
  // let match = useRouteMatch();
  const location = useLocation();
  const myparam = location.state;

  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  let tabsList = [
    {
      name: "Subscription Details",
      child: SubDetails,
    },
    {
      name: "Extend Subscription",
      child: ExtendSubscription,
    },
  ];

  const viewInvestmentDetails = (object) => {
    history.push({
      pathname: investmentDetailsPath,
      state: myparam,
    });
  };

  return (
    <div className={(classes.root, "pb30")}>
      {/* <Grid
        item
        xs={12}
        sm={6}
        md={5}
        className="overviewbar"
        style={{ marginBottom: 10 }}
      >
        <Button
          variant="outlined"
          color="default"
          startIcon={<ArrowBackIosIcon />}
          onClick={viewInvestmentDetails}
        >
          Back
        </Button>
      </Grid> */}
      <Grid container>
        <Grid item style={{ marginRight: 10 }}>
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            onClick={viewInvestmentDetails}
            style={{ borderRadius: 0 }}
          >
            Back
          </Button>
        </Grid>
        <Grid item>
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
              indicatorColor="primary"
              textColor="primary"
              TabIndicatorProps={{ style: { display: "none" } }}
            >
              {tabsList.map((text, index) => (
                <Tab
                  label={text.name}
                  key={index}
                  {...a11yProps(index)}
                  style={{ borderRadius: 20 }}
                />
              ))}
            </Tabs>
          </AppBar>
        </Grid>
      </Grid>
      {tabsList.map((object, index) => {
        return (
          <TabPanel value={value} index={index} key={"tab" + index}>
            {React.createElement(object.child, object.props)}
          </TabPanel>
        );
      })}
    </div>
  );
}
export default InvestmentTabs;
